// extracted by mini-css-extract-plugin
export default {"detailCard":"BuyerBriefView_detailCard__lkUaN","headerTitle":"BuyerBriefView_headerTitle__CMrk8","backLink":"BuyerBriefView_backLink__k5TFx"};